// export default {
//   install(Vue) {
//     Vue.filter('comma', function (value){
//       if (value == null) return value
//       let target = value.toString()
//       if (!/^\d+$/.test(target)) return value
//       return target.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
//     })

//     Vue.filter('zero_hyphen', function (value){
//       if (value == null) return value
//       let target = value.toString()
//       if (!/^0$/.test(target)) return value
//       return value.replace(/^0$/g, '-')
//     })

//     Vue.filter('zero_hyphen_yen', function (value){
//       if (value == null) return value
//       let target = value.toString()
//       if (!/^0$/.test(target)) return value + "円"
//       return value.replace(/^0$/g, '-')
//     })

//     Vue.filter('yen', function (value){
//       if (value == null) return value
//       return value + "円"
//     })
//   }
// }

export default {
  comma(value){
    if (value == null) return value
    let target = value.toString()
    if (!/^\d+$/.test(target)) return value
    return target.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  },
  zero_hyphen(value){
    if (value == null) return value
    let target = value.toString()
    if (!/^0$/.test(target)) return value
    return value.replace(/^0$/g, '-')
  },
  zero_hyphen_yen(value){
    if (value == null) return value
    let target = value.toString()
    if (!/^0$/.test(target)) return value + "円"
    return value.replace(/^0$/g, '-')
  },
  yen(value){
    if (value == null) return value
    return value + "円"
  },
}